export const whiteListRequest = [
  "/api/v1/user/login/sms",
  "/api/v1/user/login",
  "/api/v1/user/sms/send_code",
  "/api/v1/user/sms/verify_code",
  "/api/v1/user/register",
  "/api/v1/user/reset_password",
  "/api/v1/user/exist_phone_number",
  "/api/v1/user/users/qunfeng/authorize",
  "/api/v1/user/public/config?key=app_config",
  "/api/v1/user/verify",
];
